module.exports = __webpack_public_path__ + "img/about-case1.53f782db.jpg";